import React from "react";
import { Link } from "react-router-dom";
import "./PhoneNav.css";

function PhoneNav(props) {
  const { image22, className } = props;

  return (
    <div className={`phone-nav ${className || ""}`}>
      <div className="flex-row">
        <img className="vector" src="/img/vector@2x.png" />
        <Link to="/home">
          <img className="image-22" src={image22} />
        </Link>
        <Link to="/menu" className="align-self-flex-center">
          <div className="group-307">
            <img className="line-16" src="/img/line-16@2x.png" />
            <img className="line-1" src="/img/line-16@2x.png" />
            <img className="line-1" src="/img/line-16@2x.png" />
          </div>
        </Link>
      </div>
      <img className="line-12" src="/img/line-12@2x.png" />
    </div>
  );
}

export default PhoneNav;
